module.exports = __webpack_public_path__ + "img/logo_Y.30ecc541.png";